// @flow
import type {SagaIterator} from 'redux-saga';

import {call} from 'redux-saga/effects';
import {addRolloutEventListener} from 'libs/rolloutExtensionEventListener/rolloutExtensionEventListener';

/**
 * Rollout Flags Extension Saga
 */
export function* rolloutFlagsSaga(): SagaIterator {
    yield call(addRolloutEventListener);
}
